module.exports = __webpack_public_path__ + "static/media/logo.2f269ed0.png";